export const GatedDefault = () => {
  return (
    <div className="flex justify-center items-center h-full w-full bg-gradient-to-br from-slate-900 to-slate-700 text-white font-sans overflow-hidden relative">
      <div className="p-14 rounded-3xl bg-slate-900/70 backdrop-blur-xl shadow-[0_25px_50px_-12px_rgba(0,0,0,0.5),0_0_0_1px_rgba(255,255,255,0.1)] text-center max-w-[750px] w-4/5 border border-white/10 animate-[floatSlow_6s_infinite_ease-in-out]">
        <div className="text-[2.2rem] text-sky-400 font-bold mb-6">License Required to Display Content</div>

        <div className="text-lg leading-relaxed opacity-80 mx-auto max-w-[92%]">
          This screen does not have a license assigned. To activate this screen, either add more licenses to your
          subscription or delete other screens to free up an available license.
        </div>
      </div>
    </div>
  )
}
